<template>
  <div class="container">
    <div class="logining">正在登录...</div>
  </div>
</template>
<style>
  .logining{
    text-align:center;
    margin-top:100px;
  }
</style>
<script>
import Auth from '@/libs/auth'
import directive from '@/libs/directive.mixin'
export default {
  name: 'tklogin',
  mixins: [directive],
  data () {
    return {
      loading:false
    }
  },
  methods: {
    tklogin(){
      let token     = this.$route.query.tk
      let referer   = this.$route.query.referer
      if(!token){
        this.$router.push({path:'/login?referer='+referer})
        return;
      }
      let post_data = {token:token}
      this.$http.post('tklogin',post_data)
      .then(response=>{
        Auth.setLocalLogin(response.body.data)
        let path = '/base'
        setTimeout(()=>{
          let query = {}
          if(this.$route.query.referer){
            path = this.$route.query.referer
            for(let o in this.$route.query){
              if(o !== 'referer'){
                query[o] = this.$route.query[o]
              }
            }
          }
          this.$router.replace({ path: path ,query:query})
        },1000)
        
      },response=>{
        this.$router.push({path:'/login?referer='+referer})
      })
    }
  },
  mounted() {
    this.tklogin()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tklogin.vue